import React from 'react';
import { isEmpty } from 'ramda';
import { Icon, Typography } from '@groupby/ui-components';
import { Button } from '@/components/button';
import { Tooltip } from '@/search-for-retail/generic';
import { StyledBulkActionsRowContainer } from './bulk-actions-menu.styles';
import { useLocalization } from '@/localization';
function singularizeWord(word) {
    if (word.length <= 1) {
        return word;
    }
    if (/ies$/i.test(word)) {
        return word.replace(/ies$/i, 'y');
    }
    if (/s$/i.test(word) && !/ss$/i.test(word)) {
        return word.slice(0, -1);
    }
    return word;
}
export function normalizeSelectionLabel(selectionLabel) {
    if (typeof selectionLabel !== 'string') {
        return selectionLabel;
    }
    const normalized = selectionLabel.trim();
    const match = normalized.match(/^1\s+(.+?)\s+Selected$/);
    if (!match) {
        return selectionLabel;
    }
    const words = match[1].split(/\s+/);
    const lastWord = words.pop();
    if (!lastWord) {
        return selectionLabel;
    }
    const singularLastWord = singularizeWord(lastWord);
    if (singularLastWord === lastWord) {
        return selectionLabel;
    }
    return `1 ${[...words, singularLastWord].join(' ')} Selected`;
}
export const BulkActionsMenu = ({ handleDeleteSelected, handlePromoteToArea, isEditingAllowed, selectionLabel = '0 Rules selected', disableBulkCopy, disableBulkDelete = false, deleteTooltipProps, }) => {
    const { formatMessage: t } = useLocalization();
    const normalizedSelectionLabel = normalizeSelectionLabel(selectionLabel);
    const deleteButton = (<Button disabled={disableBulkDelete} error={!disableBulkDelete} rounded onClick={handleDeleteSelected} startIcon={<Icon variant="delete" tooltipText={t({ key: 'DELETE' })}/>} title={t({ key: 'DELETE' })}/>);
    return (<StyledBulkActionsRowContainer>
    <div>
      <Typography noWrap strong variant="subtitle1">
        {normalizedSelectionLabel}
      </Typography>
    </div>
    {isEditingAllowed
            && (<div>
          {handlePromoteToArea && (<Tooltip arrow title={disableBulkCopy ? t({ key: 'COPY_TO_AREA_DISABLED_TOOLTIP_GENERIC' }) : ''}>
              <span>
                <Button disabled={disableBulkCopy} onClick={handlePromoteToArea} startIcon={<Icon variant="moveFolder" tooltipText={t({ key: 'BULK_COPY_CONFIGS_TO_AREA' })}/>} title={t({ key: 'COPY_TO_AREA' })} rounded/>
              </span>
            </Tooltip>)}
          {handleDeleteSelected && isEmpty(deleteTooltipProps) ? (deleteButton) : (<Tooltip {...deleteTooltipProps}>
                <span>
                  {deleteButton}
                </span>
              </Tooltip>)}
          </div>)}
    </StyledBulkActionsRowContainer>);
};
export default BulkActionsMenu;
